export default {
    getChatList: (state, getters, rootState, rootGetters) => {
        return state.chatList;
    },
    getCurrentReceiveMessage: (state, getters, rootState, rootGetters) => {
        return state.currentReceiveMessage;
    },
    isChatSent: (state, getters, rootState, rootGetters) => {
        return state.isChatSent;
    }
}
